import { AnyModule, LogicModule, ModuleType, ProcessStatus, socketDefs } from 'game/state/BotState';
import { Processor } from '../Processor';

const logicInputs = Object.values(socketDefs[ModuleType.Logic]).filter(socketDef => {
  return socketDef.direction === 'in';
});

const INPUT_COUNT = logicInputs.length;

export const logicProcessor: Processor<LogicModule> = (module, ctx) => {
  const { modules } = ctx.bot.props.state;
  let result: ProcessStatus = { status: 'null' };
  for (let i = 0; i < INPUT_COUNT; i++) {
    const input = (module as AnyModule).inputs[i];
    if (!input) continue;
    const parent = modules.find(m => m.id === input.moduleId);
    if (!parent) continue;
    result = ctx.processOther(parent, ctx);
    if (result.status === 'running') return result;
    if (result.status === 'success') {
      if (module.operation === 'fallback') {
        return result;
      }
      continue;
    }
    if (module.operation === 'sequence') {
      return result;
    }
  }
  return result;
};
